import React, {useContext} from 'react';

import Header from "../Header";
import {Link} from "react-router-dom";
import routes from "../../../../constants/Routes";
import myAssessment from "../../../../assets/img/sidebar/my-assessment.svg";
import AppContext from "../../../../contexts/AppContext";
import myCalender from "../../../../assets/img/sidebar/my-calender.svg";
import GLOBAL from "../../../../global";
import { useTenantFeatures } from "../../../../features/tenantFeatures/useTenantFeature";

const PackageHeaderWrapper = () => {
    const { authenticated } = useContext(AppContext);
    const { isAthleteEnabled } = useTenantFeatures();

    // const location = useLocation();
    // const [pageHeader, setPageHeader] = useState('');

    // useEffect(() => {
    //     handleSetPageHeader();
    // }, [location?.search]);

    // const handleSetPageHeader = () => {
    //     let query = new URLSearchParams(location?.search);
    //     let assessmentNameFromUrl = query.get(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME) || 'Select a Plan';
    //
    //     setPageHeader(assessmentNameFromUrl);
    // }

    return (
        <Header>
            <div className="d-flex flex-grow-1 justify-content-end align-items-center font-family-outfit">
                {/*<p className="font-size-heading-md color-white font-medium m-0">{pageHeader}</p>*/}
                {
                    authenticated && (
                        <div className="d-flex">
                            {/*<Link to={isAthleteEnabled ? `${routes.myAssessments}/false` : routes.dashboard} className="kt-menu__link kt-menu__toggle mr-5">*/}
                            {/*    <div className={`kt-menu__item  kt-menu__item--submenu header-menu-container text-white font-size-20`} aria-haspopup="true">*/}
                            {/*        <img className="kt-mr-15 svg-icon-white" src={myAssessment} alt="Dashboard" />*/}
                            {/*        <span>Dashboard</span>*/}
                            {/*    </div>*/}
                            {/*</Link>*/}

                            {/*<Link to={routes.plans} className="kt-menu__link kt-menu__toggle">*/}
                            {/*    <div className={`kt-menu__item  kt-menu__item--submenu header-menu-container text-white font-size-20`} aria-haspopup="true">*/}
                            {/*        <img className="kt-mr-15 svg-icon-white" src={myCalender} alt="Plans" />*/}
                            {/*        <span>Plans</span>*/}
                            {/*    </div>*/}
                            {/*</Link>*/}
                        </div>
                    )
                }
            </div>
        </Header>
    )
};

export default PackageHeaderWrapper;
